/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { PositionDto } from './position-dto';
import { SizeDto } from './size-dto';
/**
 *
 *
 * @export
 * @interface VisualizationDto
 */
export interface VisualizationDto {
  /**
   * Type of visualization to render.
   *
   * @type {string}
   * @memberof VisualizationDto
   * @example table
   */
  type: VisualizationDtoTypeEnum;

  /**
   * Data source configuration for this visualization.
   *
   * @type {string}
   * @memberof VisualizationDto
   */
  data_source: string;

  /**
   * Position of the top-left corner of the visualization.
   *
   * @type {PositionDto}
   * @memberof VisualizationDto
   * @example {"x":0,"y":0}
   */
  position: PositionDto;

  /**
   * Dimensions of the visualization.
   *
   * @type {SizeDto}
   * @memberof VisualizationDto
   * @example {"w":400,"h":300}
   */
  size: SizeDto;

  /**
   * Visualization-specific parameters (e.g. axis labels, colors, legend toggle).
   *
   * @type {{ [key: string]: any; }}
   * @memberof VisualizationDto
   * @example {"x_axis":"created_at","y_axis":"count","color":"#4f46e5"}
   */
  parameters?: { [key: string]: any };
}

/**
 * @export
 * @enum {string}
 */
export enum VisualizationDtoTypeEnum {
  Table = 'table',
  LineChart = 'line_chart',
  AreaChart = 'area_chart',
  BarChart = 'bar_chart',
  Card = 'card',
}
